import React, { useState } from "react";
import { myroutes } from "../../routes/webroute";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
import Swal from "sweetalert2";
import $ from "jquery";

export default function ForgotPassword(){

    const [email, setEmail] = useState('');
    const [loading, isLoading] = useState(false)
    const navigate = useNavigate()

    ///###########"METHODES ///////////////"
    const handleSubmit = async (event) => {
        event.preventDefault() 
        isLoading(true)
        let form = { email}
        await AuthService.forgetPassword(form).then((response) => {
            if (!response.data.erreur) {
                Swal.fire({
                  icon: 'success',
                  title: 'Email envoyé',
                  text: response.data.message,
                });
                //Vider le champ du formulaire et griser le bouton Valider
                $("#reg-email").val("")
                $("#valider").attr("disabled", true) 
                isLoading(false)

                //navigate(myroutes.new_password);
              } else{
                Swal.fire({
                  icon: 'error',
                  title: 'Erreur!',
                  text: response.data.erreur,
                });
                isLoading(false)
              }
        }).catch(error => {
            isLoading(false)
            Swal.fire({
                icon: 'error',
                title: 'Erreur!',
                text: error,
              });
            console.log(error)
        })
    }

    return(
        <React.Fragment>
            <div className="row g-0 app-auth-wrapper">
                <div className="col-12 col-md-7 col-lg-6 auth-main-col text-center p-5">
                    <div className="d-flex flex-column align-content-end">
                        <div className="app-auth-body mx-auto">
                            <div className="app-auth-branding mb-4"><a className="app-logo" href="/"><img className="logo-icon me-2" src="../startup/img/logo-digiweb.png" alt="logo" style={{ width: "150px", height: "150px" }} /></a></div>
                            <h2 className="auth-heading text-center mb-5">Changement de mot de passe</h2>
                            <div className="auth-form-container text-start">
                                 
                                <form className="auth-form resetpass-form" onSubmit={handleSubmit}>
                                    <div className="email mb-3">
                                        <label className="sr-only" htmlFor="reg-email">Email</label>
                                        <input id="reg-email" value={email} minLength={5} maxLength={100} name="reg-email" onChange={(e) => setEmail(e.target.value)} type="email" className="form-control login-email border border-info" placeholder="Email" required="required" />
                                    </div>{/*//form-group*/}
                                    <div className="text-center">
                                        <button  className="btn app-btn-primary bg-primary text-white w-100 theme-btn mx-auto" id="valider">{loading === false ? "Valider" : "En cours..."}</button>
                                    </div>
                                </form>
                                <div className="auth-option text-center pt-5"><Link to={myroutes.login}> Se connecter </Link></div>
                                <div className="auth-option text-center pt-2">Pas de compte?</div>
                                <div className="auth-option text-center pt-2">S'inscrire en tant que  <Link className="text-link" to={myroutes.register} style={{ fontWeight: "bold" }} > Particulier ici</Link>.</div>
                                <div className="auth-option text-center pt-2"> S'inscrire en tant que <Link className="text-link" to={myroutes.register_entreprise} style={{ fontWeight: "bold" }} > Entreprise ici</Link>.</div>

                            </div>{/*//auth-form-container*/}

                        </div>{/*//auth-body*/}

                        <footer className="app-auth-footer">
                            <div className="container text-center py-3">
                                <small className="copyright">Conception réalisée par <span className="sr-only">love</span><i className="fas fa-heart" style={{ color: "#fb866a" }}></i> <a className="app-link" href="https://www.digiweb.bj/" target="_blank">Digiweb SARL</a> 2023</small>

                            </div>
                        </footer>{/*//app-auth-footer*/}
                    </div>{/*//flex-column*/}
                </div>{/*//auth-main-col*/}
                <div className="col-12 col-md-5 col-lg-6 h-100 auth-background-col app-signup">
                    <div className="auth-background-holder">
                    </div>
                    <div className="auth-background-mask">
                    </div>
                </div>

            </div>{/*//row*/}
        </React.Fragment>
    )
}